<template>
    <div class="alert" :class="`alert--${type}`" v-if="show">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'Alert',
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        type: {
            validator(value) {
                // The value must match one of these strings
                return ['success', 'warning', 'danger', 'info'].indexOf(value) !== -1;
            },
            default: 'info',
        },
    },
};
</script>
<style lang="scss" scoped>
.alert {
    padding: 16px;
    background: $color-info;
    color: $color-info-dark;
    font-size: 16px;
    line-height: 22px;
    position: relative;
    margin: 16px 0;
    text-align: left;
    border-radius: 4px;
    &--info {
        background-color: $color-info;
        color: $color-info-dark;
    }
    &--danger {
        background-color: $color-danger;
        color: $color-danger-dark;
    }
    &--warning {
        background-color: $color-warning;
        color: $color-warning-dark;
    }
    &--success {
        background-color: $color-success;
        color: $color-success-dark;
    }
    &--custom-subscription {
        background-color: #b7ebd5;
        color: $color-success-dark;
    }
}
</style>
